
<div class="hero-container">
<section class="hero">
        <div class="hero-content">
            <h1>11+ Creative Writing Help Club</h1>
            <p>Unleash your child's creativity and boost their writing skills to the next level.</p>
            
            <div class="exam-badges">
                <span class="badge">CSSE</span>
                <span class="badge">FSCE</span>
                <span class="badge">HBS</span>
                <span class="badge">SET</span>
                <span class="badge">Independent Schools</span>
            </div>

            <div class="schedule-box">
                <div class="schedule-item">
                    <span class="icon">📅</span>
                    <span><strong>Weekly</strong> – Every Wednesday, 4–5 PM</span>
                </div>
                <div class="schedule-item">
                    <span class="icon">🎉</span>
                    <span><strong>First Session FREE</strong></span>
                </div>
                <div class="schedule-item">

                    <a href="#register" class="btn">Register Now!</a>
                </div>
            </div>
        </div>

        <div class="hero-image">
            <img src="assets/images/creative-writing.png" alt="Student writing creatively">
            <div class="floating-element float-1"></div>
            <div class="floating-element float-2"></div>
        </div>
    </section>
</div>




    <section class="section">
        <h2 class="section-title">Why Join the Creative Writing Help Club?</h2>
        <p style="text-align: center; font-size: 20px; color: #666; margin-bottom: 50px;">Our programme is designed to help children develop strong creative writing skills that are essential for 11+ entrance exams.</p>

        <div class="benefits-grid">
            <div class="benefit-card">
                <h3>✨ Creativity & Imagination</h3>
                <p>Develop unique storytelling abilities and original ideas that captivate readers and examiners.</p>
            </div>
            <div class="benefit-card">
                <h3>📚 Grammar & Vocabulary</h3>
                <p>Master essential language skills with weekly vocabulary building and grammar refinement.</p>
            </div>
            <div class="benefit-card">
                <h3>🎭 Narrative Techniques</h3>
                <p>Learn professional storytelling methods including plot development, character creation, and dialogue.</p>
            </div>
            <div class="benefit-card">
                <h3>📝 Structure & Organisation</h3>
                <p>Build well-organized stories with clear beginnings, middles, and endings that flow naturally.</p>
            </div>
            <div class="benefit-card">
                <h3>🎨 Descriptive Techniques</h3>
                <p>Create vivid imagery using sensory details and powerful descriptive language.</p>
            </div>
            <div class="benefit-card">
                <h3>🎯 Exam-focused Writing</h3>
                <p>Practice with real exam-style prompts and receive targeted feedback for test success.</p>
            </div>
        </div>

        <p style="text-align: center; font-size: 22px; margin-top: 50px; color: #0B7AB5; font-weight: bold;">Your child learns through fun, engaging and structured sessions — supported by expert guidance and weekly writing practice.</p>
    </section>

    <section class="dark-section">
        <h2 class="section-title" style="color: white;">Programme Overview</h2>
        <p style="text-align: center; font-size: 20px; margin-bottom: 50px;">Students receive a combination of live instruction, writing time, guided tasks, and personalised feedback.</p>

        <div class="program-overview">
            <div class="po-img">
                <img src="assets/images/cw-feature.jpeg" alt="Student learning">
            </div>
            <div>
                <h3 style="font-size: 32px; margin-bottom: 30px; color: #FFBF00;">What's Included</h3>
                <ul class="included-list">
                    <li>Live Online Session (1 hour)</li>
                    <li>Mini-lesson + Notes</li>
                    <li>Writing Prompt</li>
                    <li>Vocabulary List</li>
                    <li>Writing Time + Live Feedback</li>
                    <li>Homework Challenge</li>
                    <li>Written Marking & Feedback</li>
                </ul>
            </div>
        </div>
    </section>

    <section class="section" id="register">
        <h2 class="section-title">Plans & Pricing</h2>
        <p style="text-align: center; font-size: 20px; color: #666; margin-bottom: 50px;">Choose the learning style that suits your child best.</p>

        <div class="pricing-cards">
            <div class="pricing-card">
                <div class="plan-number">1️⃣</div>
                <h3>Live Weekly Session + Full Support</h3>
                <div class="schedule-item">
                    <span class="icon">📅</span>
                    <span>Every Wednesday</span>
                </div>
                <div class="schedule-item">
                    <span class="icon">🕒</span>
                    <span>4–5 PM</span>
                </div>
                <div class="price">£7.99/week</div>
                <div class="price-alt">OR £22 per month (4 sessions)</div>
                
                <ul class="included-list">
                    <li>Live Online Session</li>
                    <li>Mini-Lesson with Notes</li>
                    <li>Writing Prompt</li>
                    <li>Vocabulary List</li>
                    <li>Homework Challenge</li>
                    <li>Written Marking & Feedback</li>
                </ul>
                
                <a href="#" class="btn" style="width: 100%; text-align: center; margin-top: 20px;">Choose This Plan</a>
            </div>

            <div class="pricing-card">
                <div class="plan-number">2️⃣</div>
                <h3>Writing Pack, Review & Marking Only</h3>
                <div style="height: 60px;"></div>
                <div class="price">£9.99/month</div>
                <div class="price-alt">(4 prompts)</div>
                
                <ul class="included-list">
                    <li>Writing Prompts</li>
                    <li>Vocabulary List</li>
                    <li>Homework Challenge</li>
                    <li>Written Marking & Feedback within 24 hours</li>
                </ul>
                
                <p style="margin: 20px 0; color: #666; font-style: italic;">Ideal for students who prefer self-paced writing but still want expert review and improvement guidance.</p>
                
                <a href="#" class="btn" style="width: 100%; text-align: center; margin-top: 20px;">Choose This Plan</a>
            </div>
        </div>
    </section>

    <section class="section" style="background: #F5F5F5;">
        <h2 class="section-title">Who Is It For?</h2>
        <p style="text-align: center; font-size: 20px; margin-bottom: 40px;">The programme is perfect for students preparing for:</p>
        
        <div style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">CSSE</div>
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">FSCE</div>
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">HBS</div>
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">SET</div>
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">Independent Schools</div>
            <div class="badge" style="font-size: 18px; padding: 15px 30px;">Private School Exams</div>
        </div>
    </section>

    <section class="cta-section">
        <h2>Ready to Unlock Your Child's Writing Potential?</h2>
        <p>Join hundreds of students improving their creative writing skills every week</p>
        <a href="#register" class="btn btn-white">Start Your FREE First Session</a>
    </section>